// extracted by mini-css-extract-plugin
export default {"container":"Oficial_container__plQW7","containerOptions":"Oficial_containerOptions__4fJSl","texts":"Oficial_texts__IUWoY","div_middle":"Oficial_div_middle__MhQtg"};